import * as React from 'react'
import type { SVGProps } from 'react'
import type { Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgApartment = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 12 12'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='{props.color} #000'
      fillOpacity={0.6}
      d='M4.005 6.5a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1zM6.005 6.5a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1zM8.005 6.5a.5.5 0 0 1 0 1H8a.5.5 0 0 1 0-1zM4.005 4.5a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1zM6.005 4.5a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1zM8.005 4.5a.5.5 0 0 1 0 1H8a.5.5 0 0 1 0-1zM4.005 2.5a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1zM6.005 2.5a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1zM8.005 2.5a.5.5 0 0 1 0 1H8a.5.5 0 0 1 0-1z'
    />
    <path
      fill='{props.color} #000'
      fillOpacity={0.6}
      fillRule='evenodd'
      d='M9 .5A1.5 1.5 0 0 1 10.5 2v8A1.5 1.5 0 0 1 9 11.5H3A1.5 1.5 0 0 1 1.5 10V2A1.5 1.5 0 0 1 3 .5zm-6 1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h1v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h1a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5zm2 9h2v-1H5z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgApartment)
export default ForwardRef
